import { Modal, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

export const AccountingRemovalModal = ({
  isOpen,
  closeModal,
  onConfirm,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => void;
}) => {
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: accounting removal modal title",
        defaultMessage: "You must connect an accounting platform or upload management accounts",
      })}
      primaryAction={{
        onAction: closeModal,
        content: intl.formatMessage({
          id: "funding-application: accounting modal - connect platform",
          defaultMessage: "Keep this platform",
        }),
      }}
      tertiaryAction={{
        onAction: () => {
          onConfirm();
          closeModal();
        },
        content: intl.formatMessage({
          id: "funding-application: accounting modal - use management accounts",
          defaultMessage: "Upload documents instead",
        }),
      }}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <TextContainer>
        <Text>
          {intl.formatMessage({
            id: "funding-application: accounting modal - need accounting data",
            defaultMessage:
              "You must connect an accounting platform or provide us with your management accounts (Profit & Loss Statement and Balance Sheet) in excel format. Together with your banking data, this gives us important information about the overall financial health of your business to inform our funding decision.",
          })}
        </Text>
        <Text>
          {intl.formatMessage({
            id: "funding-application: accounting modal - chat to us message",
            defaultMessage:
              "If you need help, chat to us using the link on this page or reach out to your Wayflyer representative directly if you have one.",
          })}
        </Text>
      </TextContainer>
    </Modal>
  );
};

export const ManagementAccountsRemovalModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: management accounts removal modal title",
        defaultMessage: "Sorry, removing this is not possible",
      })}
      primaryAction={{
        onAction: closeModal,
        content: intl.formatMessage({
          id: "funding-application: accounting modal - okay",
          defaultMessage: "Okay",
        }),
      }}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <TextContainer>
        <Text>
          {intl.formatMessage({
            id: "funding-application: accounting modal - need management accounts",
            defaultMessage:
              "You must either connect an accounting platform by clicking ‘Add another’ or provide us with your Profit & Loss Statement and Balance Sheet in Excel or PDF format. Together with your banking data, this gives us important information about the overall financial health of your business to inform our funding decision.",
          })}
        </Text>
        <Text>
          {intl.formatMessage({
            id: "funding-application: accounting modal - chat to us message",
            defaultMessage:
              "If you need help, chat to us using the link on this page or reach out to your Wayflyer representative directly if you have one.",
          })}
        </Text>
      </TextContainer>
    </Modal>
  );
};
